module.exports = __webpack_public_path__ + "static/2-ba23960662587d46a950fdf06e7a6bfa.jpg";